import {
    FlowBlock,
    FlowPoint,
    FlowPort,
    FlowPortKind
} from '@mintdata-wsp/common/state/ui/visualDesigner/FlowState';

export class FlowUtil
{
    public static readonly PORT_HEIGHT:number = 16;
    public static readonly PORT_WIDTH:number = 16;
    public static readonly WIRE_THICKNESS:number = 3.0;
    public static readonly BLOCK_HEIGHT:number = 64;
    public static readonly SHADOW_THICKNESS:number = 3;

    public static getAbsolutePortPosition(block:FlowBlock, port:FlowPort):FlowPoint
    {
        const isInputPort = port.kind === FlowPortKind.InputPort;
        const blockPosition = block.bounds.position;
        const portOffset = FlowUtil.getPortOffsetFromBlock(block, port);

        const portWidth = FlowUtil.PORT_WIDTH;
        const portHeight = FlowUtil.PORT_HEIGHT;
        const wireThickness = FlowUtil.WIRE_THICKNESS;
        let dxForWire;
        let dyForWire;

        if( !isInputPort )
        {
            const blockWidth:number = block.bounds.size.width;

            dxForWire = blockWidth + portWidth;
            dyForWire = (portHeight / 2) + Math.ceil(wireThickness / 2);
        }
        else
        {
            dxForWire = FlowUtil.SHADOW_THICKNESS;
            dyForWire = (portHeight / 2) + Math.ceil(wireThickness / 2);
        }

        const wireOffset = new FlowPoint(dxForWire, dyForWire);
        const absolutePortPos = blockPosition.add(portOffset).add(wireOffset);

        return absolutePortPos;
    }

    public static getPortOffsetFromBlock(block:FlowBlock, port:FlowPort):FlowPoint
    {
        const isInputPort = port.kind === FlowPortKind.InputPort;
        const pt = FlowUtil.getPortTargetAreaOffsetFromBlock(block, port);

        if( isInputPort )
            return pt.add(new FlowPoint(10, 3.0));
        else
            return pt.add(new FlowPoint(0, -1));
    }

    public static getPortTargetAreaOffsetFromBlock(block:FlowBlock, port:FlowPort):FlowPoint
    {
        const isInputPort = port.kind === FlowPortKind.InputPort;

        let portIndex;
        let numPorts;

        if( isInputPort )
        {
            portIndex = block.inputPorts.findIndex((p) => (p.id === port.id));
            numPorts = block.inputPorts.length;
        }
        else
        {
            portIndex = block.outputPorts.findIndex((p) => (p.id === port.id));
            numPorts = block.outputPorts.length;
        }

        const inputOffsetX = -9;
        const outputOffsetX = -11;
        let offsetY = NaN;

        if( isInputPort )
        {
            if( numPorts == 1 )
                offsetY = 20;
            else if( numPorts == 2 )
                offsetY = 7 + portIndex * 25;
            else
                console.log('Error: > 2 input ports not supported in rendering FlowBlocks (yet)');
        }
        else
        {
            if( numPorts == 1 )
                offsetY = 24;
            else if( numPorts == 2 )
                offsetY = 10.5 + portIndex * 25;
            else
                console.log('Error: > 2 output ports not supported in rendering FlowBlocks (yet)');
        }

        const point = new FlowPoint(isInputPort ? inputOffsetX : outputOffsetX, offsetY);
        return point;
    }

}
